import gsap from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);

export default class FloatNav {
    constructor() {
        this._init();
    }

    _init() {
        this.tabClass();
        this.tabNone();
        this.contOver();
        this.anchorPoint();
    }

    //追従クリックで検索タブオープン・クローズ
    tabClass() {
        const floatAll = document.querySelector(".js-float");
        const floatTtl = document.querySelector(".js-float_ttl");

        floatTtl.addEventListener("click", () => {
            floatAll.classList.toggle("-open");
            floatAll.classList.toggle("-close");
        });
    }

    //FVで日付に追従が被る場合は、追従を画面からオフ
    tabNone() {
        const floatAll = document.querySelector(".js-float");
        const floatTtl = document.querySelector(".js-float_ttl");
        const mv = document.querySelector(".js-mv");

        const classNone = () => {
            const mvHeight = mv.getBoundingClientRect().height;
            const mvBottom = mv.getBoundingClientRect().bottom;
            const floatTtlHeight = floatTtl.getBoundingClientRect().height;
            const viewHeight = document.documentElement.clientHeight;

            if (viewHeight <= mvHeight + floatTtlHeight * 0.75) {
                if (floatAll.classList.contains("-close") && mvBottom >= viewHeight - floatTtlHeight + floatTtlHeight * 0.25) {
                    floatAll.classList.add("-none");
                } else {
                    floatAll.classList.remove("-none");
                }
            } else {
                floatAll.classList.remove("-none");
            }
        };

        window.addEventListener("load", classNone);
        window.addEventListener("scroll", classNone);
        window.addEventListener("resize", classNone);
    }

    //コンテンツ範囲を超えたら追従をオフする
    contOver() {
        const floatAll = document.querySelector(".js-float");
        const main = document.querySelector(".js-main");

        window.addEventListener("scroll", () => {
            const mainBottom = main.getBoundingClientRect().bottom;
            const viewBottom = window.innerHeight;

            if (mainBottom <= viewBottom) {
                floatAll.classList.add("-nonefoot");
            } else {
                floatAll.classList.remove("-nonefoot");
            }
        });
    }

    anchorPoint() {
        const point = document.querySelector(".js-point");
        const anchorBtn = document.querySelector(".js-anchor_point");

        anchorBtn.addEventListener("click", () => {
            gsap.to(window, {
                duration: 1,
                scrollTo: {
                    y: point,
                    // offsetY: 0,
                },
                ease: "power2.out",
            });
        });
    }
}
